
<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block_new search">
      <Form :label-width="100" inline>
        <FormItem label="医院编码" class="mb-2">
          <Select
            placeholder="请选择"
            clearable
            v-model="table.search.HospitalCode"
            style="width: 186px"
          >
            <Option
              v-for="item in hospitalList"
              :value="item.organCode"
              :key="item.organID"
              >{{ item.organName }}({{ item.organCode }})</Option
            >
          </Select>
        </FormItem>
        <FormItem label="检查类型">
          <Input
            placeholder="请输入"
            v-model="table.search.StudyModality"
          ></Input>
          <!-- <Select class="w-250" v-model="table.search.StudyModality" clearable multiple>
          <Option
            v-for="(item, index) in ExamTypeSelect"
            :value="item.dictionaryValue"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select> -->
        </FormItem>

        <FormItem label="检查编号">
          <Input
            placeholder="请输入"
            v-model="table.search.AccessionNumber"
          ></Input>
        </FormItem>
        <FormItem label="患者编号">
          <Input placeholder="请输入" v-model="table.search.ParentID"></Input>
        </FormItem>
        <FormItem label="患者姓名">
          <Input
            placeholder="请输入"
            v-model="table.search.PatientName"
          ></Input>
        </FormItem>
        <FormItem label="患者性别">
          <Select
            class="w-250"
            v-model="table.search.patientSex"
            clearable
            style="width: 186px"
          >
            <Option value="M">男 </Option>
            <Option value="F">女 </Option>
          </Select>
        </FormItem>
        <FormItem label="开始时间">
          <DatePicker
            type="date"
            format="yyyy-MM-dd"
            :value="table.search.begintime"
            @on-change="change_begintime"
            placeholder="选择开始时间"
            style="width: 186px"
          ></DatePicker>
        </FormItem>
        <FormItem label="结束时间">
          <!-- <span>-</span> -->
          <DatePicker
            type="date"
            format="yyyy-MM-dd"
            :value="table.search.endtime"
            @on-change="change_endtime"
            placeholder="选择结束时间"
            style="width: 186px"
          ></DatePicker>
        </FormItem>
        <FormItem label="影像设备">
          <Select
            class="w-250"
            v-model="table.search.FromAE"
            clearable
            style="width: 186px"
          >
            <Option
              v-for="item in formAeList"
              :key="item.id"
              :value="item.applicationCode"
              >{{ item.applicationCode }}</Option
            >
          </Select>
        </FormItem>
        <Button class="ml-5 possion" type="success" @click="search"
          >查询</Button
        >
      </Form>
      <!--操作区域-->
      <div></div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--详情-->
    <Modal
      v-model="studyModal"
      title="详情"
      :footer-hide="true"
      :closable="false"
      width="700"
    >
      <studydetail
        v-if="studyModal"
        @close="studyModal = false"
        :currentData="currentData"
      ></studydetail>
    </Modal>
    <!--SeriesInfo-->
    <Modal
      v-model="SeriesModal"
      title="序列"
      :footer-hide="true"
      :closable="false"
      :width="1200"
    >
      <seriesinfolist
        v-if="SeriesModal"
        @close="SeriesModal = false"
        :StudyId="StudyId"
      ></seriesinfolist>
    </Modal>
    <!--ImageInfo-->
    <Modal
      v-model="ImageModal"
      title="图像"
      :footer-hide="true"
      :closable="false"
      width="80"
    >
      <imageinfolist
        v-if="ImageModal"
        @close="ImageModal = false"
        :StudyId="StudyId"
      ></imageinfolist>
    </Modal>
    <Modal
      v-model="NotDICOM_show"
      title="非DCM文件影像"
      :footer-hide="true"
      :closable="false"
      width="1200"
    >
      <!-- <h1>非DCM文件影像</h1> -->
      <div>
        <ul class="imgList">
          <li v-for="(item, i) in ImageUrlNotDICOM" :key="i">
            <img :src="item" alt="" />
          </li>
        </ul>
      </div>
    </Modal>
    <!-- 影像路由 -->
    <Modal
      v-model="imageRouterShow"
      title="影像转发"
      :footer-hide="true"
      :closable="false"
      width="1200"
    >
      <!-- wc -->
      <!-- <Table
        :data="IRList"
        height="500"
        :columns="IRColumns"
        highlight-row
        size="small"
        stripe
        border
      ></Table> -->
      <Form :label-width="69" inline>
        <FormItem label="时间范围">
          <DatePicker
            type="daterange"
            v-model="rangeDateNodes"
            :start-date="new Date()"
            placement="bottom-end"
            placeholder="请选择时间范围"
            style="width: 200px"
          />
        </FormItem>
        <Button type="primary" style="margin: 0 12px 0 0" @click="TosearchNodes()"
          >查询</Button
        >
        <Button @click="resetNodes()">重置</Button>
      </Form>
      <div style="display: flex; align-items: center">
        <h4 style="margin-right: 30px">转发节点</h4>
        <Button type="primary" @click="routeHandle(routerNodes)"
          >开始转发</Button
        >
      </div>
 
      <CheckboxGroup
        v-model="routerNodes"
        style="margin-top: 20px; margin-bottom: 20px"
        @on-change="changeBox"
      >
        <Checkbox
          :label="JSON.stringify(item)"
          v-for="(item, index) in IRList"
          :key="index"
          >{{ item.scuName }}</Checkbox
        >
      </CheckboxGroup>
      <Table
        :data="routeList"
        height=""
        :columns="IRColumns"
        highlight-row
        stripe
        border
      ></Table>
      <Page
        @on-change="changePage"
        :total="total"
        :page-size="10"
        style="text-align: center; margin-top: 10px"
      />
      <div class="ml-5 mt-5 text-center modal-foter">
        <Button @click="imageRouterShow = false">关 闭</Button>
      </div>
    </Modal>
    <!-- 影像路由日志 -->
    <Modal
      v-model="logShow"
      title="日志"
      :footer-hide="true"
      :closable="false"
      width="1200"
    >
      <Form :label-width="69" inline>
        <FormItem label="日志级别">
          <Select
            v-model="params.type"
            :label-in-value="true"
            style="width: 200px"
          >
            <Option
              v-for="(item, index) in levelList"
              :value="item.type"
              :key="index"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="时间范围">
          <DatePicker
            type="daterange"
            v-model="rangeDate"
            :start-date="new Date()"
            placement="bottom-end"
            placeholder="请选择时间范围"
            style="width: 200px"
          />
        </FormItem>
        <Button type="primary" style="margin: 0 12px 0 0" @click="Tosearch()"
          >查询</Button
        >
        <Button @click="reset()">重置</Button>
      </Form>
      <Table
        :data="logList"
        height=""
        :columns="logColumns"
        highlight-row
        size="small"
        stripe
        border
      >
      </Table>
      <Page
        :total="totalLog"
        @on-change="changePageLog"
        :page-size="10"
        style="text-align: center; margin-top: 20px"
      />
      <div class="ml-5 mt-5 text-center modal-foter">
        <Button @click="logShow = false">关 闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import axios from "axios";
import studydetail from "../study/detail.vue";
import seriesinfolist from "../study/seriesinfolist.vue";
import imageinfolist from "../study/imageinfolist.vue";
import { oosState } from "@/utils";
import moment from "moment";
// import func from 'vue-editor-bridge';
const dayjs = require("dayjs");
const formattedTime = dayjs().format("YYYYMMDD");

export default {
  components: { DataTable, studydetail, seriesinfolist, imageinfolist },
  data: function () {
    return {
      relationID: "",
      rangeDate: [],
      rangeDateNodes:[dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"),dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss")],
      params: {
        startTime: "",
        endTime: "",
        type: "",
        n: "",
        pageSize: 10,
        i: 1,
      },
      levelList: [
        {
          name: "跟踪",
          type: "Trace",
        },
        {
          name: "调试",
          type: "Debug",
        },
        {
          name: "信息",
          type: "Information",
        },
        {
          name: "警告",
          type: "Warning",
        },
        {
          name: "错误",
          type: "Error",
        },
        {
          name: "严重",
          type: "Critical",
        },
      ],
      currentPage: 1,
      total: 0,
      currentPageLog: 1,
      totalLog: 0,
      logList: [],
      routeList: [],
      studyID: "",
      logShow: false,
      boxes: [
        {
          id: 1,
          name: "111",
          count: "333333",
        },
        {
          id: 2,
          name: "222",
          count: "444",
        },
      ],
      routerNodes: [], //路由节点
      imageRouterShow: false,
      IRList: [],
      formAeList: [],
      IRColumns: [
        {
          title: "序号",
          key: "",
          type: "index",
          width: "60",
          align: "center",
        },
        { title: "本地AE", key: "aEing", align: "center" },
        { title: "服务AE", key: "aEed", align: "center" },
        { title: "端口", key: "port", align: "center" },
        { title: "ip", key: "ip", align: "center" },
        { title: "创建时间", key: "createTime", align: "center" },
        {
          title: "路由状态",
          key: "imageStatus",
          align: "center",
          render: (h, params) => {
            return h(
              "div",
              params.row.imageStatus == "0"
                ? "等待转发"
                : params.row.imageStatus == "1"
                ? "正在转发"
                : params.row.imageStatus == "2"
                ? "转发成功"
                : params.row.imageStatus == "3"
                ? "转发失败"
                : ""
            );
          },
        },
        {
          title: "操作",
          width: "220px",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    //marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.reRouter(params.row.id);
                    },
                  },
                },
                "重新转发"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    //marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.showLog(params.row.id);
                    },
                  },
                },
                "查看日志"
              ),
            ]);
          },
        },
      ],
      logColumns: [
        {
          title: "序号",
          key: "",
          type: "index",
          width: "60",
          align: "center",
        },
        { title: "日志级别", key: "logLevel", align: "center" },
        { title: "日志内容", key: "context", align: "center" },
        { title: "创建时间", key: "createTime", align: "center" },
      ],
      IRStudyID: "",
      ImageUrlNotDICOM: [], //非DCM文件数数据
      NotDICOM_show: false, //非DCM文件数数据_判断

      ExamTypeSelect: [], //检查类型
      currentData: {},
      deleteData: {},
      studyModal: false,
      addModal: false,
      SeriesModal: false,
      ImageModal: false,
      StudyId: "",
      table: {
        columns: [
          //   {
          //     type: "selection",
          //     width: 60,
          //     align: "center",
          //   },
          {
            title: "序号",
            fixed: "left",
            type: "index",
            width: "60",
            align: "center",
          },
          {
            width: "100",
            title: "医院编码",
            key: "organCode",
            align: "center",
          },
          { width: "110", title: "患者编号", key: "parentID", align: "center" },
          {
            width: "100",
            title: "检查编号",
            key: "accessionNumber",
            align: "center",
            tooltip: true,
          },
          {
            width: "120",
            title: "患者姓名",
            key: "patientName",
            align: "center",
          },
          {
            width: "60",
            title: "性别",
            key: "patientSex",
            align: "center",
            render: (h, params) => {
              return h(
                "div",
                params.row.patientSex == "F"
                  ? "女"
                  : params.row.patientSex == "M"
                  ? "男"
                  : ""
              );
            },
          },
          {
            width: "100",
            title: "患者年龄",
            key: "patientAge",
            align: "center",
          },
          {
            width: "100",
            title: "出生日期",
            key: "patientBirthday",
            align: "center",
          },
          {
            width: "130",
            title: "检查描述",
            key: "studyDescription",
            align: "center",
            tooltip: true,
          },
          {
            width: "130",
            title: "检查主键",
            key: "studyID",
            align: "center",
            tooltip: true,
          },
          {
            width: "130",
            title: "STUDYUID",
            key: "studyInstanceUID",
            align: "center",
            tooltip: true,
          },
          {
            width: "100",
            title: "影像类型",
            key: "imgFileType",
            align: "center",
            render: (h, params) => {
              return h(
                "div",
                params.row.imgFileType == 0 || params.row.imgFileType == 1
                  ? "DICOM"
                  : "非DICOM"
              );
            },
          },
          {
            width: "100",
            title: "影像数量",
            key: "imageCount",
            align: "center",
          },
          {
            width: "120",
            title: "是否回写ris",
            key: "risImageCountFlag",
            align: "center",
            render: (h, params) => {
              return h(
                "div",
                params.row.risImageCountFlag == 0
                  ? "未回写/无需回写"
                  : params.row.risImageCountFlag == 1
                  ? "已回写"
                  : "回写失败"
              );
            },
          },
          {
            width: "120",
            title: "是否手动匹配",
            key: "handmatch",
            align: "center",
            render: (h, params) => {
              return h(
                "div",
                params.row.handmatch == 0
                  ? "未匹配/无需匹配"
                  : params.row.handmatch == 1
                  ? "已匹配"
                  : "匹配失败"
              );
            },
          },
          {
            width: "140",
            title: "最后更新时间",
            key: "lastUpdateDate",
            align: "center",
          },
          {
            width: "100",
            title: "检查类型",
            key: "studyModality",
            align: "center",
          },
          {
            width: "110",
            title: "OOS存储状态",
            key: "oosUploadFlag",
            align: "center",
            render: (h, params) => {
              return h(
                "div",
                params.row.oosUploadFlag == null
                  ? "未压缩"
                  : oosState[params.row.oosUploadFlag]
              );
            },
          },
          { width: "100", title: "影像设备", key: "fromAE", align: "center" },
          {
            width: "100",
            title: "设备厂商",
            key: "deviceManufacture",
            align: "center",
          },
          {
            width: "110",
            title: "检查部位名称",
            key: "examBodyName",
            align: "center",
          },
          { width: "100", title: "检查日期", key: "examDate", align: "center" },
          {
            width: "110",
            title: "检查项目名称",
            key: "examItemName",
            align: "center",
          },
          { width: "100", title: "检查时间", key: "examTime", align: "center" },
          {
            width: "100",
            title: "存储路径",
            key: "pathDetail",
            align: "center",
          },
          { width: "100", title: "RIS标记", key: "rISFlag", align: "center" },
          {
            width: "100",
            title: "序列数量",
            key: "serieseCount",
            align: "center",
          },
          {
            width: "100",
            title: "层厚",
            key: "slicethickness",
            align: "center",
          },
          {
            width: "100",
            title: "工作站名",
            key: "stationname",
            align: "center",
          },
          { width: "100", title: "窗位", key: "winCenter", align: "center" },
          { width: "100", title: "窗宽", key: "winWide", align: "center" },
          {
            title: "操作",
            fixed: "right",
            width: "400px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      //marginRight: "5px",
                      color: "#3795C8",
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "详情"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      //marginRight: "5px",
                      color: "#3795C8",
                    },
                    on: {
                      click: () => {
                        this.toPassBack(params.row);
                      },
                    },
                  },
                  "重新QA"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      //marginRight: "5px",
                      color: "#3795C8",
                    },
                    on: {
                      click: () => {
                        this.toSeries(params.row);
                      },
                    },
                  },
                  "序列"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      //marginRight: "5px",
                      color: "#3795C8",
                    },
                    on: {
                      click: () => {
                        this.toImage(params.row);
                      },
                    },
                  },
                  "图像"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      //marginRight: "5px",
                      color: "#3795C8",
                    },
                    on: {
                      click: () => {
                        this.imageRouting(params.row.studyID);
                      },
                    },
                  },
                  "影像转发"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      //marginRight: "5px",
                      color: "#3795C8",
                    },
                    on: {
                      click: () => {
                        this.look_Image(params.row);
                      },
                    },
                  },
                  "查看影像"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      //marginRight: "5px",
                      color: "#FA6266",
                    },
                    on: {
                      click: () => {
                        this.toDelete(params.row);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        startDateTime:'',
        endDateTime:'',
        apiUrl: "StudyInfo/getList",
        search: {
          HospitalCode: "",
          StudyModality: "",

          AccessionNumber: "", //检查编号
          ParentID: "", //患者编号
          PatientName: "", //患者姓名
          patientSex: "", //患者性别

          begintime: formattedTime, //开始时间
          endtime: formattedTime, //结束时间
          FromAE: "",
          PageIndex: 1,
          PageSize: 20,
        },
      },
    };
  },
  created() {},

  computed: {
    hospitalList() {
      return this.$store.state.hospitalList;
    },
  },
  activated: function () {
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      this.ExamTypeSelect = data;
    });
    this.search();
  },
  methods: {
    reset(){
      this.params={}
      this.rangeDateNodes=[]
      this.getLog()
    },
    resetNodes(){
      this.rangeDateNodes=[dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"),dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss")]
      this.endDateTime=this.rangeDateNodes[0],
      this.startDateTime=this.rangeDateNodes[1]
      this.getImgList()
    },
    TosearchNodes(){
      
      this.startDateTime = this.rangeDateNodes[0]
        ? moment(this.rangeDateNodes[0]).format("YYYY-MM-DD") + " 00:00:00"
        : "";
      this.endDateTime = this.rangeDateNodes[1]
        ? moment(this.rangeDateNodes[1]).format("YYYY-MM-DD") + " 23:59:59"
        : "";
        this.getImgList()
    },
    Tosearch() {
      this.params.startTime = this.rangeDate[0]
        ? moment(this.rangeDate[0]).format("YYYY-MM-DD") + " 00:00:00"
        : "";
      this.params.endTime = this.rangeDate[1]
        ? moment(this.rangeDate[1]).format("YYYY-MM-DD") + " 23:59:59"
        : "";
      this.getLog();
    },
    changePage(val) {
      this.currentPage = val;
      this.getImgList();
    },
    changePageLog(val) {
      this.currentPageLog = val;
      this.getLog();
    },
    showLog(id) {
      console.log(id, "日志id");
      this.relationID = id;
      this.logShow = true;
      this.getLog();
    },
    changeBox(item) {
      // this.routerNodes=item.map(x => {
      //  return JSON.parse(JSON.stringify(x))
      // });
      // this.routerNodes=item
      // console.log(this.routerNodes);
      // this.routerNodes=JSON.parse(item)
      // console.log(JSON.parse(item));
    },
    search: function () {
      this.table.search.begintime = this.table.search.begintime;
      // console.log(this.table.search.begintime);
      this.$refs.dataTable.initload();
    },
    change_begintime(value) {
      // value.split("-")
      // console.log("666",value.split("-").join(''));
      this.table.search.begintime = value.split("-").join("");
      console.log(this.table.search.begintime);
    },
    change_endtime(value) {
      // value.split("-")
      // console.log("666",value.split("-").join(''));
      this.table.search.endtime = value.split("-").join("");
    },
    // 显示
    toDetail: function (data) {
      this.studyModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },
    toDelete: function (data) {
      this.$Modal.confirm({
        title: "确认要删除吗？",
        mask: false,
        onOk: () => {
          this.deleteData = JSON.parse(JSON.stringify(data.studyID));
          console.log("查看删除data", data.studyID);
          // this.$api.get("StudyInfo/DeleteStudy?studyid=",data.studyID).then((rsp) => {
          this.$api
            .get("StudyInfo/DeleteStudy?studyID=" + data.studyID)
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
        },
      });
    },
    // 回传
    // toPassBack: function (data) {
    //   this.$Modal.confirm({
    //     title: "确认要重新QA吗？",
    //     mask: false,
    //     onOk: () => {
    //       this.$api
    //         .get("Study/ImageBack?studyID=" + data.studyID)
    //         .then((rsp) => {
    //           if (rsp != false) {
    //             this.$Message.success("操作成功");
    //             this.search();
    //           }
    //         });
    //     },
    //   });
    // },
    toPassBack: function (data) {
      this.$Modal.confirm({
        title: "确认要重新QA吗？",
        mask: false,
        onOk: () => {
          this.$api
            .get("StudyInfo/AnewQA?studyID=" + data.studyID)
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("操作成功");
                this.search();
              }
            });
        },
      });
    },
    getLog() {
      // const dayStart = dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss");
      // const dayEnd = dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss");

      let data = {
        IndexNo: this.currentPageLog,
        pageSize: 10,
        // ip: "",
        logtype: this.params.type,
        relationID: this.relationID,
        startDateTime: this.params.startTime,
        endDateTime: this.params.endTime,
      };
      this.$api.post("/StudyInfo/GetRouteLog", data).then((rsp) => {
        this.logList = rsp.data;
        this.totalLog = rsp.dataCount;
        console.log(rsp);
        // if (rsp != false) {
        //   this.innerList = rsp.data;
        // }
      });
    },
    getImgList() {
      const dayStart = dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss");
      const dayEnd = dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss");
      console.log(dayEnd);
      let data = {
        pageIndex: this.currentPage,
        pageSize: 10,
        ip: "",
        startDateTime: this.startDateTime,
        endDateTime: this.endDateTime,
      };
      this.$api.post("/StudyInfo/GetImageRouteList", data).then((rsp) => {
        this.routeList = rsp.data.list;
        this.total = rsp.data.total;
        console.log(rsp);
        // if (rsp != false) {
        //   this.innerList = rsp.data;
        // }
      });
    },
    imageRouting(studyID) {
      this.studyID = studyID;
      console.log(studyID, 666);
      this.$api
        .get("/api/ArchiveService/GetAllRouteNodes?studyID=" + studyID)
        .then((rsp) => {
          if (rsp != false) {
            this.IRList = rsp.data;
          }
        });
      this.getImgList();
      this.IRStudyID = studyID;
      this.imageRouterShow = true;
    },
    reRouter(id) {
      this.$api
        .post(
          "/StudyInfo/UpdateRouteStatus",
          { id },
          {
            headers: {
              "Content-Type": "text/plain", // 使用 text/plain 作为 Content-Type
            },
          }
        )
        .then((rsp) => {
          if (rsp != false) {
            // this.imageRouterShow = false;
            this.$Message.success("操作成功");
            this.getImgList();
          }
        });
    },
    routeHandle(id) {
      // let ids=JSON.parse(id)
      let parsedArray = id.map((jsonString) => JSON.parse(jsonString));

      parsedArray.forEach((item) => {
        item.studyId = this.studyID;
      });
      console.log(parsedArray, "test");
      this.$api
        .post("/StudyInfo/AddImageJoinRoute", parsedArray)
        .then((rsp) => {
          if (rsp != false) {
            // this.imageRouterShow = false;
            this.$Message.success("操作成功");
            this.getImgList();
          }
          this.routerNodes = [];
        });
    },
    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toSeries: function (data) {
      this.SeriesModal = true;
      this.StudyId = data.studyID;
    },
    toImage: function (data) {
      this.ImageModal = true;
      this.StudyId = data.studyID;
    },
    look_Image: function (data) {
      const { accessionNumber, studyID, organCode } = data;
      let new_data = {
        accessionNumber: accessionNumber,
        studyUID: studyID,
        hospitalCode: organCode,
        studyID,
      };
      this.image_have(new_data);
      /*
      console.log("数据",data);
      // 判断有没有影像
      axios.post("http://archive4.cloud.dicomclub.com:81/WxNoAuth/ImageIsExists", new_data).then((rsp) => {
        if (rsp.data.Result == "200") {
          if (rsp.data.Data.IsExist == true) {//有影像
              // 有影像 -- 再判断是否是dom和非dom
              if (res.data.Data.Type == '0' || res.data.Data.Type == '1') {
                // 调阅dcm文件
                this.image_have(new_data)
              }else if(res.data.Data.Type == '2' ){
                //非DCM文件
                axios.post("http://archive4.cloud.dicomclub.com:81/WxNoAuth/GetImageUrlNotDICOM", new_data).then((rsp) => {
                  if (rsp.Data) {
                    this.ImageUrlNotDICOM = rsp.Data.map(item => item);
                    // window.open(rsp.Data)
                    console.log("非dom地址",rsp.Data);
                    this.NotDICOM_show = true //弹框开启
                    }
                });
              }else{
                // 使用远程影像
                 axios.post("http://archive4.cloud.dicomclub.com:81/Image/GetWPACSVIEWUrl", new_data).then((rsp) => {
                  if (rsp.data.Result == "200") {
                    window.open(rsp.Data)
                    console.log("远程影像",rsp.Data);
                    }
                });
              }
          }else{
            // this.image_have(new_data)
            this.$Message.error("暂无影像");
          }
          // console.log('拼接',rsp);
        }
      });
      */
    },
    // 有影像调影像
    image_have(new_data) {
      console.log(new_data);
      const screenageType = localStorage.getItem("screenageType");
      if (screenageType == 1) {
        //影像类型1  地址
        axios
          .post(imageUrl + "/Image/GetWPACSVIEWUrl", {
            accessionNumber: "",
            hospitalCode: new_data.hospitalCode,
            studyUID: new_data.studyUID,
          })
          .then((rsp) => {
            if (rsp.data.Url) {
              window.open(rsp.data.Url);
            }
          })
          .catch((err) => {
            this.$Message.error("请求失败请重试");
          });
      } else if (screenageType == 2) {
        let new_data2 = {
          ProviderID: defaultProviderID,
          Data: {
            HospitalCode: new_data.hospitalCode,
            HospitalCodes: new_data.hospitalCode,
            AccessionNumber: new_data.accessionNumber,
            StudyIDs: new_data.studyID,
          },
        };
        axios
          .post(imageUrl + "/Image/GetImageUrlByAccNo", new_data2)
          .then((rsp) => {
            // console.log(r);
            if (rsp.data.data.imageAddress) {
              window.open(rsp.data.data.imageAddress);
            }
          })
          .catch((err) => {
            this.$Message.error("请求失败请重试");
          });
      } else if (screenageType == 3) {
        let new_data3 = {
          ProviderID: defaultProviderID,
          Data: {
            HospitalCode: new_data.hospitalCode,
            HospitalCodes: new_data.hospitalCode,
            AccessionNumber: new_data.accessionNumber,
            StudyIDs: new_data.studyID,
          },
        };
        axios
          .post(imageUrl + "/Image/GetImageUrls", new_data3)
          .then((rsp) => {
            console.log(rsp);
            if (rsp.data.data.imageAddress) {
              window.open(rsp.data.data.imageAddress);
            }
          })
          .catch((err) => {
            this.$Message.error("请求失败请重试");
          });
      }
      /*
        if(screenageType==1){//影像类型1  地址
          axios.post("http://archive4.cloud.dicomclub.com:81/Image/GetWPACSVIEWUrl", new_data).then((res) => {
              window.location = res.data.Data.Url
          });
        }else if(screenageType==2){
          let new_data2 ={   
              ProviderID: 'CIoLi6ErdDzDGoKN',
              Data: {
                HospitalCode: new_data.hospitalCode,
                HospitalCodes: new_data.hospitalCode,
                AccessionNumber: new_data.accessionNumber
              }
          }
           axios.post("http://archive4.cloud.dicomclub.com:81/Image/GetImageUrlByAccNo", new_data2).then((res) => {
            window.location.href = res.data.Data.imageAddress
            });
        }else if(screenageType==3){
            let new_data3 ={   
              ProviderID: 'CIoLi6ErdDzDGoKN',
              Data: {
                HospitalCode: new_data.hospitalCode,
                HospitalCodes: new_data.hospitalCode,
                AccessionNumber: new_data.accessionNumber
              }
            }
            axios.post("http://archive4.cloud.dicomclub.com:81/Image/GetImageUrls", new_data3).then((rsp) => {
            window.location = res.data.Data.imageAddress
            });
        }
        */
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style lang="less" scoped>
.search_block_new {
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  // align-items: center;
  // flex-wrap: wrap;
  background: #fff;
  padding: 15px 0 0;
  border-radius: 10px;
  margin-bottom: 10px;
  .ivu-form-item {
    // margin-bottom: 0;
  }
  .ivu-form .ivu-form-item-label {
    color: #6e849e;
  }
  .ivu-select,
  .ivu-date-picker {
    width: 186px;
  }
}
.search {
  display: flex;
  align-items: flex-end;
}
.possion {
  // margin-bottom: 20px;
}
.imgList {
  list-style: none;
  padding: 0;
  li {
    margin-bottom: 20px;
    img {
      width: 100%;
    }
  }
}
</style>